import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Register from "components/auth/Register";
import Login from "components/auth/Login";
import Session from "pages/Session";
import Hands from "pages/Hands";
import Viewer from "components/hands/jsx/Viewer";
import { useAuth } from "components/auth/context/useAuth";
import { SessionProvider } from "components/sessions/context/SessionContext";
import { PokerGameProvider } from "components/hands/context/PokerGameContext";

// AppShell holds navigation and route config, keeping App.js lean.
function AppShell() {
  const { user, loading, logout } = useAuth();

  return (
    <Router>
      <div className="App">
        <Navbar bg="dark" variant="dark" expand="lg" className="body">
          <Container>
            <Navbar.Brand as={Link} to="/">
              livegraph io
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/hands">
                  see Hands
                </Nav.Link>
                <Nav.Link as={Link} to="/uploadhand">
                  upload Poker Hand
                </Nav.Link>
              </Nav>
              <Nav className="ms-auto align-items-center gap-3">
                {loading ? null : user ? (
                  <NavDropdown
                    title={user.email}
                    id="user-nav-dropdown"
                    align="end"
                  >
                    <NavDropdown.Item as={Link} to="/myhands">
                      my Hands
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/mygraph">
                      my Graph
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/mysessions">
                      my Sessions
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={logout}>logout</NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <>
                    <Nav.Item className="d-flex align-items-center">
                      <Login showLogoutButton={false} />
                    </Nav.Item>
                    <NavDropdown
                      title="Account"
                      id="auth-nav-dropdown"
                      align="end"
                    >
                      <NavDropdown.Item as={Link} to="/register">
                        register
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <hr />
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/mysessions"
            element={
              <SessionProvider>
                <Session user={user} />
              </SessionProvider>
            }
          />
          <Route
            path="/uploadhand"
            element={
              <PokerGameProvider>
                <Hands />
              </PokerGameProvider>
            }
          />
          <Route
            path="/view/:userId/:pokerHandId"
            element={
              <PokerGameProvider>
                <Viewer />
              </PokerGameProvider>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default AppShell;
